var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPii = function SvgPii(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "PI Icon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2927"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.821,
    cy: 18.326,
    fill: "currentColor",
    "data-name": "Ellipse 114",
    rx: 18.821,
    ry: 18.326,
    transform: "translate(12.066 3.395)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.888 76.606c-7.427 0-14.477-1.5-19.851-4.225-5.355-2.715-8.509-6.369-8.883-10.286h-.04c0-.181 0-.349.008-.5-.008-.1-.008-.195-.008-.29a8.3 8.3 0 0 1 .181-1.71 18 18 0 0 1 1.591-5.193 21 21 0 0 1 3.172-4.762 28.47 28.47 0 0 1 12.732-8.045 23.1 23.1 0 0 0 11.1 2.728 23.1 23.1 0 0 0 11.099-2.728c.9.29 1.784.618 2.635.975a17 17 0 0 0-.215 2.681 16.57 16.57 0 0 0 4.423 11.29 16.56 16.56 0 0 0 10.827 5.275v.276h-.035c-.374 3.919-3.53 7.573-8.884 10.288-5.374 2.726-12.426 4.226-19.852 4.226m22.194-27.04a3.58 3.58 0 0 1-2.709-.837 4.84 4.84 0 0 1-.979-3.477v-.17a25.8 25.8 0 0 1 5.185 4.4 16 16 0 0 1-1.497.084",
    "data-name": "Subtraction 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495867",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "M62.376 59.098a15.491 15.491 0 0 1-10.951-26.445 15.49 15.49 0 1 1 21.906 21.906 15.4 15.4 0 0 1-10.955 4.539Zm-5.707-16.419a2.684 2.684 0 0 0-1.618 4.83l6.575 4.955 8.611-11.461a2.686 2.686 0 0 0-4.292-3.23l-5.382 7.163-2.283-1.72a2.66 2.66 0 0 0-1.611-.537Z",
    "data-name": "Subtraction 11"
  })))));
};
export default SvgPii;